
export function isEquals(a: number,b:number, sigma: number = 0.0001): boolean{
    if (Math.abs(a-b) < sigma)
        return true;
    return false;
}

export function Random(){
    // const mult = 1073676287;
    // const div = 115;
    // return ((Math.random()*mult)%div)/div;
    return Math.random();
}